import "@/app/style/raceHeader.scss";
import CalendarSvgIcon from "@/app/ui/Common/SvgComponent/CalendarSvgIcon";
import React from 'react';

type propType = {
    onClickCalendar?: () => void;
    isCalendarShown: boolean;
    isAltTheme?: boolean;
};

const CalendarIconButton: React.FC<propType> = (props: propType) => {
    return (
        <div className={`calendarIconBtn${props.isAltTheme ? " --white" : ""}${props.isCalendarShown ? " --selected" : ""}`}
            onClick={props.onClickCalendar}
            id="btnCalendar">
            <CalendarSvgIcon />
        </div>
    )
};

export default CalendarIconButton